import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './paymentSuccess.module.css';
import Header from '../../components/standartComponents/header';

const PaymentSuccess = ({ authUser }) => {
  const navigate = useNavigate();

  return (
    <>
      <Header authUser={authUser} />
      
      <div className={classes.wrap}>
        {/* HERO */}
        <div className={classes.hero}>
          <div className={classes.sparkles}>
            <div className={classes.sparkle}></div>
            <div className={classes.sparkle}></div>
            <div className={classes.sparkle}></div>
            <div className={classes.sparkle}></div>
            <div className={classes.sparkle}></div>
            <div className={classes.sparkle}></div>
          </div>
          <div className={classes.successIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
          </div>
          <h1>Оплата успішна!</h1>
          <p>Ваш тариф Premium активовано. Тепер вам доступні всі можливості AI Lingua.</p>
        </div>

        {/* SUMMARY */}
        <div className={classes.summary}>
          <div className={classes.sumT}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
            Деталі підписки
          </div>
          <div className={classes.sumGrid}>
            <div className={classes.sumI}><div className={classes.sumL}>Тариф</div><div className={classes.sumV}>Premium</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Статус</div><div className={`${classes.sumV} ${classes.ok}`}>✓ Активна</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Сума</div><div className={classes.sumV}>299 грн / міс</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Списання</div><div className={classes.sumV}>19.06.2026</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Оплата</div><div className={classes.sumV}>Visa **** 1234</div></div>
            <div className={classes.sumI}>
              <div className={classes.sumL}>Кабінет</div>
              <div className={classes.sumV}><Link to="/profile" style={{ color: 'var(--indigo-500)', textDecoration: 'none', fontSize: '12px' }}>Керувати →</Link></div>
            </div>
          </div>
        </div>

        {/* CHOICE SECTION */}
        <div className={classes.choiceSection}>
          <div className={classes.choiceTitle}>Як хочете почати навчання?</div>
          <div className={classes.choiceSub}>Оберіть зручний формат — персональний план або самостійне навчання з відео.</div>
          <div className={classes.choiceGrid}>
            <div className={`${classes.choiceCard} ${classes.primary}`} onClick={() => navigate('/survey')}>
              <span className={classes.choiceBadge}>★ Рекомендовано</span>
              <div className={`${classes.choiceIcon} ${classes.ciPlan}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              </div>
              <h3>Отримати персональний план</h3>
              <p className={classes.chDesc}>Створіть курс під вашу ціль і рівень. Ми підберемо уроки та порядок навчання.</p>
              <div className={classes.chDetail}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>Це займе менше 1 хвилини
              </div>
              <button className={`${classes.chCta} ${classes.chCtaPrimary}`}>
                Створити мій план<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
            </div>
            
            <div className={classes.choiceCard} onClick={() => navigate('/allvideos')}>
              <div className={`${classes.choiceIcon} ${classes.ciFree}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
              </div>
              <h3>Навчатися без плану</h3>
              <p className={classes.chDesc}>Обирайте будь-які відео та практикуйтеся у власному темпі без фіксованого порядку.</p>
              <div className={classes.chDetail}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>Ви завжди зможете створити план пізніше
              </div>
              <button className={`${classes.chCta} ${classes.chCtaSecondary}`}>
                Перейти до всіх відео<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
              </button>
            </div>
          </div>
          <div className={classes.choiceNote}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>Ви зможете перемикатися між цими режимами в будь-який момент.
          </div>
        </div>

        {/* FEATURES */}
        <div className={classes.features}>
          <div className={classes.featT}>Що тепер доступно</div>
          <div className={classes.featG}>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f1}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg></div><h4>Персональний план</h4><p>Курс під вашу ціль і рівень.</p></div>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f2}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg></div><h4>Усі відеоуроки</h4><p>Повний каталог відео без обмежень.</p></div>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f3}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg></div><h4>AI Speaking</h4><p>Практикуйте діалоги з AI.</p></div>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f4}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg></div><h4>Особистий словник</h4><p>Зберігайте слова та повторюйте.</p></div>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f5}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div><h4>Прогрес навчання</h4><p>Уроки, слова, відео та streak.</p></div>
            <div className={classes.fc}><div className={`${classes.fi} ${classes.f6}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg></div><h4>Самостійне навчання</h4><p>Будь-які відео без плану.</p></div>
          </div>
        </div>

        <div className={classes.sup}>
          <p>Питання щодо оплати?</p>
          <Link to="/profile"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Зв'язатися з підтримкою</Link>
        </div>

      </div>

      {/* FOOTER */}
      <div className={classes.foot}>
        <div className={classes.footIn}>
          <div className={classes.footC}>© 2026 AI Lingua. Всі права захищені.</div>
          <div className={classes.footL}>
            <Link to="/termsOfUse">Умови використання</Link>
            <Link to="/privacy">Політика конфіденційності</Link>
            <Link to="/cancelAndRefund">Повернення коштів</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
